export default "__VITE_ASSET__DjuRgTxv__"